import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import Amplify, { Auth } from 'aws-amplify';
import { from, Observable } from 'rxjs';
import { LoggerService, LOG_LEVEL } from './logger.service';

// import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    // identityPoolId: environment.userPoolId,

    // REQUIRED - Amazon Cognito Region
    region: environment.region,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: environment.userPoolId,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: environment.clientId,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,

    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    // cookieStorage: {
    //   // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //   domain: '.d2do7yqt4r946x.cloudfront.net/',
    //   // OPTIONAL - Cookie path
    //   path: '/',
    //   // OPTIONAL - Cookie expiration in days
    //   expires: 1,
    //   // OPTIONAL - Cookie secure flag
    //   // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    //   secure: true,
    // },

    // OPTIONAL - Hosted UI configuration
    oauth: {
      domain: 'ps-cc-platform-app.auth.us-east-1.amazoncognito.com',
      scope: [
        'phone',
        'email',
        'profile',
        'openid',
        'aws.cognito.signin.user.admin',
      ],
      redirectSignIn: environment.redirectSignIn,
      redirectSignOut: environment.redirectSignOut,
      responseType: 'token', // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
});

/**
 * Login Service used to federate user with Cognito
 *
 * @export LoginService
 */
@Injectable({
  providedIn: 'root',
})
export class LoginService {
  /**
   * Token value
   */
  token = '';

  /**
   * Creates an instance of LoginService.
   * @param router Angular Web App router
   */
  constructor(private router: Router) {}

  /**
   * Attempts to see if the user is currently logged in
   *
   * @returns async boolean determining logged in status
   */
  public checkLogin(): Observable<boolean> {
    const loggedIn = Auth.currentSession()
      .then(data => {
        this.token = data.getIdToken().getJwtToken();
        return true;
      })
      .catch(e => {
        LoggerService.log(e, LOG_LEVEL.ERROR);
        return false;
      });
    return from(loggedIn);
  }

  /**
   * Attempts to log the current user in
   */
  public login(): void {
    Auth.federatedSignIn()
      .then(cred => {
        // If success, you will get the AWS credentials
        this.router.navigate(['/']);
        return Auth.currentAuthenticatedUser();
      })
      .then(user => {
        // If success, the user object you passed in Auth.federatedSignIn
        LoggerService.log(user, LOG_LEVEL.MESSAGE);
      })
      .catch(e => {
        LoggerService.log(e, LOG_LEVEL.ERROR);
      });
  }

  /**
   * Clears the login token data and redirects the user to the login page
   */
  public logout(): void {
    Auth.signOut();
    this.router.navigate(['login']);
  }

  /**
   * Returns the current access token used in api calls
   */
  getToken(): string {
    return this.token;
  }

  /**
   * returns the currently logged in user
   *
   * @returns async user
   */
  public getUser(): Promise<any> {
    return Auth.currentAuthenticatedUser();
  }
}
